import React, { useState, useEffect } from "react";

export default function MainReview2(reviews) {
    const [data, setData] = useState([]);
    useEffect(() => {
        setData(reviews.reviews);
    }, [reviews.reviews]);

    return (
        <>
            <div className="bg-white">
                <div className=" py-8 lg:max-w-7xl lg:mx-auto lg:px-8">
                    <div className="px-4 sm:px-6 sm:flex sm:items-center sm:justify-between lg:px-8 xl:px-0 mb-8">
                        <h2 className="lg:text-xl font-extrabold tracking-tight text-gray-900 sm:text-lg">顧客反饋</h2>
                    </div>
                    <div className="relative">
                        <div className="relative w-full pb-6 -mb-6 overflow-x-auto">
                            <ul
                                className="mx-4 inline-flex space-x-8 sm:mx-6 lg:mx-0 lg:space-x-0 lg:grid lg:grid-cols-4 lg:gap-x-8"
                            >
                                {/* content */}
                                {
                                    data.map((person, index) => (
                                        <li className="mb-4" key={index}>
                                            <div className="w-60 lg:w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                                                <a href="#">
                                                    <img className="rounded-t-lg" src={person.imgUrl} alt="" />
                                                </a>
                                                <div className="p-5">
                                                    <a href="#">
                                                        <h5 className="mb-2 text-2xl font-bold tracking-tighst text-gray-900 dark:text-white">{person.residentialName}</h5>
                                                    </a>
                                                    <p className="mb-2 font-normal text-gray-700 dark:text-gray-400">
                                                        {person.customerName}
                                                    </p>
                                                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400 leading-1.5">
                                                        {person.comment}
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                }
                                {/* end of content */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}